<template>
  <div class="dataBox">
    <span>您的申请终审被拒绝，请重新修改审核资料</span><br>
    <p class="dataP">原因：{{final_mark}}</p>
    <el-button type="warning" style="margin-top: 10px" @click="submitAgain">重新提交</el-button>
  </div>
</template>

<script>
export default {
  name: 'processDataexamine4',
  props: ['final_mark'],
  data () {
    return {}
  },
  methods: {
    // 重新提交审核事件
    submitAgain: function () {
      console.log(this.$store.state.group)
      // 判断会员类型:0是个人，1是企业
      if (this.$store.state.group === '1' || this.$store.state.group === 1) {
        this.$router.push('/enterpriseApplyAgain')
      } else if (this.$store.state.group === '0' || this.$store.state.group === 0) {
        this.$router.push('/individualApplyAgain')
      }
    }
  }
}
</script>

<style scoped>
  .dataBox{
    padding-top: 140px;
  }
  .dataBox span{
    color: #c1313f;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .dataP{
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #a2afbb;
  }
</style>



// WEBPACK FOOTER //
// src/components/joinprocess/processDataexamine4.vue